import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import { selectAppPersistOnBoardStart } from '@store/useAppStorePersist';

import style from './style.module.scss';

const ActionItemsTableBodySkeleton = () => {
  const onBoardStart = selectAppPersistOnBoardStart();

  return (
    <div className={cx(style.tableBody, { [style.onboardingTable]: onBoardStart })}>
      {[...Array(10)].map((_) => (
        <div key={uuidv4()} className={cx(style.tableBodyRowWrapper, style.skeletonTableBodyRowWrapper)}>
          <div className={cx(style.tableBodyRow, style.tableBodyRowSkeleton)}>
            <div className={style.tableBodyRowLocation}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowEquipment}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowComponent}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowType}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowWo}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowTime}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
            <div className={style.tableBodyRowUpdate}>
              <SkeletonBlock className={style.skeletonTextClassName} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActionItemsTableBodySkeleton;
